import { makeAutoObservable } from 'mobx'

const key = (contactId: number, inboxId: number) => `${contactId}_${inboxId}`

export class QuietHoursSendAnywayStore {
  private _keys: string[] = []

  constructor() {
    makeAutoObservable(this)
  }

  addKey = (contactId: number, inboxId: number) => {
    const k = key(contactId, inboxId)
    if (!this._keys.includes(k)) {
      this._keys.push(k)
    }
  }

  hasKey = (contactId: number, inboxId: number): boolean => {
    return this._keys.includes(key(contactId, inboxId))
  }
}
